/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { RicosContext, RicosNodeContext } from './../../ricos-context';
import { CollapsibleListData_InitialExpandedItems } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { NodeViewRendererProps } from './../../ricos-types';
import { anchorScroll } from './../../wix-rich-content-common';

import ExpandCollapseButton from '../components/ExpandCollapseButton';
import collapsibleListItemStyles from '../statics/styles/collapsible-list-pair.rtlignore-scss';
import { CollapsibleListContext } from './collapsibleListContext';

const CollapsibleListItem = ({ node, nodeIndex, RicosNodesRenderer }: NodeViewRendererProps) => {
  const { parentNode } = useContext(RicosNodeContext);
  const { expandedItemId, setExpandedItemId } = useContext(CollapsibleListContext);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { initialExpandedItems, expandOnlyOne } = parentNode?.collapsibleListData || {};
  const [isExpanded, setIsExpanded] = useState(
    CollapsibleListData_InitialExpandedItems.ALL === initialExpandedItems ||
      (nodeIndex === 0 && CollapsibleListData_InitialExpandedItems.FIRST === initialExpandedItems)
  );
  const { t } = useContext(RicosContext);

  const styles = collapsibleListItemStyles;

  const toggleCollapsibleListBody = () => {
    setIsExpanded(prev => !prev);
    setExpandedItemId(node.id);
    containerRef.current && anchorScroll(containerRef.current);
  };

  useEffect(() => {
    if (expandOnlyOne && expandedItemId && expandedItemId !== node.id) {
      setIsExpanded(false);
    }
  }, [expandedItemId]);

  const allChildrenList = node.nodes ?? [];
  const firstChildList = node.nodes?.[0] ? [node.nodes[0]] : [];

  return (
    <div>
      <div
        className={classNames(styles.itemContainer, styles.itemContainerViewer)}
        ref={containerRef}
      >
        <div className={styles.expandIcon}>
          <ExpandCollapseButton
            isExpanded={isExpanded}
            onClick={toggleCollapsibleListBody}
            ariaLabel={
              isExpanded
                ? t('CollapsibleListPlugin_ExpandButton_AriaLabel')
                : t('CollapsibleListPlugin_CollapseButton_AriaLabel')
            }
          />
        </div>
        <div className={styles.item}>
          <RicosNodesRenderer nodes={isExpanded ? allChildrenList : firstChildList} />
        </div>
      </div>
    </div>
  );
};

const CollapsibleListItemRenderer = ({ node, ...props }: NodeViewRendererProps) => {
  return <CollapsibleListItem key={node.id} node={node} {...props} />;
};

export default CollapsibleListItemRenderer;
